<template>
  <div v-if="loading" class="fixed inset-0 flex items-center justify-center bg-black z-50">
    <img
      src="@/assets/imgs/tuin_loader.gif"
      alt="Cargando..."
      class="w-[500px]"
    />
  </div>
</template>

<script>
  export default {
    name: "LoaderComponent",  
    props: {
      loading: {
        type: Boolean,
        required: true
      }
    }
  };
</script>